import { bindActionCreators } from "redux";
import {
  setTrip,
  saveTrip,
  updateTrip,
  resetTripRedirect,
  submitTrip,
  setTripNoEffortReason,
  setRedirect,
  deleteTrip,
  deleteEffort,
  deleteCatch,
  deleteSales
} from "../actions/newVtrTrip";
import { saveEffort, updateEffort,updateCatch } from "../actions/newEffort";
import {setError} from "../actions/errorActions";
import {updateSales,newSales} from "../actions/sales";
import {login, logout} from "../actions/middleware_actions";

export function mapDispatchToProps(dispatch) {
  return {
    actions: {
      login:bindActionCreators(login,dispatch),
      setTrip:bindActionCreators(setTrip, dispatch),
      deleteSales:bindActionCreators(deleteSales,dispatch),
      deleteCatch:bindActionCreators(deleteCatch,dispatch),
      deleteEffort:bindActionCreators(deleteEffort, dispatch),
      deleteTrip:bindActionCreators(deleteTrip, dispatch),
      saveTrip: bindActionCreators(saveTrip, dispatch),
      updateTrip: bindActionCreators(updateTrip, dispatch),
      resetTripRedirect: bindActionCreators(resetTripRedirect, dispatch),
      saveEffort: bindActionCreators(saveEffort, dispatch),
      updateEffort: bindActionCreators(updateEffort, dispatch),
      updateSales:bindActionCreators(updateSales,dispatch),
      newSales:bindActionCreators(newSales,dispatch),
      submitTrip:bindActionCreators(submitTrip,dispatch),
      setTripNoEffortReason:bindActionCreators(setTripNoEffortReason,dispatch),
      updateCatch: bindActionCreators(updateCatch, dispatch),
      setError: bindActionCreators(setError,dispatch),
      setTripRedirect: bindActionCreators(setRedirect,dispatch),
      logout:bindActionCreators(logout,dispatch)
    },
  };
}
